import type { ScenarioCard } from './types';

export const SCENARIOS: ScenarioCard[] = [
  // === RED FLAGS ===
  {
    id: 'love-bomb-1',
    kind: 'message',
    name: 'Daniel',
    context: 'first week of texting',
    content:
      "I don't usually say this, but I feel like I've been looking for you my whole life. You're already mine, even if you don't know it yet.",
    verdict: 'red',
    category: 'love-bombing',
    explanation:
      'Intense intimacy claims and ownership language before trust has been built. Healthy connection deepens; it does not instantly arrive. This is a classic pattern that can foreshadow controlling behavior.',
  },
  {
    id: 'limit-push-1',
    kind: 'profile',
    name: 'Master Apex',
    age: 38,
    content:
      'Looking for true submissives who understand that real subs don\'t need limits. If you have hard nos, you haven\'t found the right Master yet.',
    verdict: 'red',
    category: 'limit-pushing',
    explanation:
      'Frames limits as a deficiency to be overcome rather than as healthy infrastructure. Real dominants celebrate clear limits because they make trust possible. This is one of the most dangerous patterns in the community.',
  },
  {
    id: 'iso-1',
    kind: 'behavior',
    name: 'James',
    context: "you've been seeing him a month",
    content:
      "Your friend Maria seems great but I notice you come back from seeing her in a weird headspace. We're trying to build something solid here. Maybe spend a little less time with her until things settle.",
    verdict: 'red',
    category: 'isolation',
    explanation:
      'Couched in concern, but it is a request to limit a specific relationship. Healthy partners support your existing connections; they do not curate them. The "until things settle" framing makes it sound temporary while normalizing the gatekeeping.',
  },
  {
    id: 'iso-2',
    kind: 'message',
    name: 'Marcus',
    context: 'after you tell him you have plans with your sister',
    content:
      "I thought we were having dinner. I guess your family always comes first. Don't worry about it.",
    verdict: 'red',
    category: 'isolation',
    explanation:
      'Punishing you for prior commitments while pretending not to. Guilt as a tool for redirecting your time toward him. Healthy partners hear "I have plans" without resentment.',
  },
  {
    id: 'fast-1',
    kind: 'message',
    name: 'Eric',
    context: 'after your third date',
    content:
      "Move in with me. I know it's fast but when you know, you know. We'd save so much time we waste being apart.",
    verdict: 'red',
    category: 'fast-escalation',
    explanation:
      'Compressing relationship phases that exist for good reasons. The hurry usually serves the one in a hurry, not the partnership. Slow is its own form of respect.',
  },
  {
    id: 'fast-2',
    kind: 'behavior',
    name: 'Owen',
    context: 'on your first scene together',
    content:
      "He wants to skip the negotiation. Says he can read what you want, and over-talking it kills the energy.",
    verdict: 'red',
    category: 'fast-escalation',
    explanation:
      'Skipping negotiation is not "advanced," it is dangerous. Experienced dominants negotiate more, not less. "I can read you" is what people say when they want permission to assume.',
  },
  {
    id: 'dismiss-1',
    kind: 'quote',
    name: 'Lucas',
    context: 'when you mention something he said hurt',
    content:
      "You're being too sensitive. I was joking. You knew what I meant.",
    verdict: 'red',
    category: 'dismissiveness',
    explanation:
      "Reframes your reasonable reaction as your defect. The implied: you have the problem, not the words. Repeated dismissal of feelings is how a person learns to stop bringing them up.",
  },
  {
    id: 'dismiss-2',
    kind: 'behavior',
    name: 'Aaron',
    context: 'when you use your safeword',
    content:
      "He sighs, stops, and says nothing during aftercare. The next day asks if you 'really' needed to call it.",
    verdict: 'red',
    category: 'dismissiveness',
    explanation:
      'Making safeword use feel like a failure on your part. Punishing the very mechanism that keeps play safe. Safewords must be costless to use; this is the opposite.',
  },
  {
    id: 'deflect-1',
    kind: 'quote',
    name: 'Theo',
    context: 'when you ask about his last partner',
    content:
      "She was crazy. Couldn't handle this lifestyle. You're so much more grounded than her, thank god.",
    verdict: 'red',
    category: 'deflection',
    explanation:
      'Two for one: dismisses an ex as "crazy" (vague, scapegoating) and flatters you by comparison. Both patterns make it hard to learn anything real about him. Be especially curious about who his previous partners actually were.',
  },
  {
    id: 'lp-2',
    kind: 'behavior',
    name: 'Connor',
    context: 'during a negotiated bondage scene',
    content:
      'You agreed to wrists only. Mid-scene he reaches to add ankles. "Trust me, it will feel better."',
    verdict: 'red',
    category: 'limit-pushing',
    explanation:
      "Adding to a scene without re-negotiating, even in the moment, breaks the agreement. 'Trust me' from a person currently violating an agreement is its own contradiction. Stop the scene.",
  },
  {
    id: 'lp-3',
    kind: 'message',
    name: 'Hunter',
    context: 'when you said anal is a hard limit',
    content:
      "I respect that for now. We can revisit when you trust me more. Most subs eventually want it once they let go of their inhibitions.",
    verdict: 'red',
    category: 'limit-pushing',
    explanation:
      'Reframes a hard limit as a temporary condition contingent on more trust. Plants the seed that your no is a learning problem. A healthy partner accepts a hard limit as a yes-to-other-things, not a no-for-now.',
  },
  {
    id: 'iso-3',
    kind: 'behavior',
    name: 'Cole',
    context: 'two months in',
    content:
      "He has opinions about most of your friendships. Always small, always reasonable-sounding. After a while you notice you've stopped mentioning the friends he doesn't like.",
    verdict: 'red',
    category: 'isolation',
    explanation:
      'Isolation rarely arrives as a demand. It arrives as a hundred small editorial comments that train you to self-censor. Notice who you have stopped mentioning.',
  },
  {
    id: 'love-bomb-2',
    kind: 'message',
    name: 'Sebastian',
    context: 'two days after meeting',
    content:
      'No one has ever understood me like you do. I want to give you everything. Tell me what you want and it is yours.',
    verdict: 'red',
    category: 'love-bombing',
    explanation:
      'Manufactured intimacy at impossible speed. The promise of "everything" is rarely matched by capacity to deliver. Often followed, weeks later, by a sharp shift toward criticism.',
  },
  {
    id: 'deflect-2',
    kind: 'message',
    name: 'Riley',
    context: "when you ask about safety practices",
    content:
      "I've been doing this for fifteen years. I think I know what I'm doing. Are you really going to interview me?",
    verdict: 'red',
    category: 'deflection',
    explanation:
      'Experience cited as a reason not to answer specific questions. Real experience makes questions easier to answer, not insulting to be asked. Watch for defensiveness about basic vetting.',
  },

  // === GREEN FLAGS ===
  {
    id: 'vet-1',
    kind: 'message',
    name: 'Marcus',
    context: 'in response to your question',
    content:
      'Of course. I can give you the names of three former partners as references. Take all the time you need before we meet in person.',
    verdict: 'green',
    category: 'vetting-readiness',
    explanation:
      'Offers references without defensiveness and explicitly supports slow pacing. This is what serious practitioners do.',
  },
  {
    id: 'transp-1',
    kind: 'behavior',
    name: 'Alex',
    context: 'at the end of a scene',
    content:
      "I noticed I was pulling harder than we'd negotiated for impact. I shouldn't have. Are you okay? Let's talk about what to do differently next time.",
    verdict: 'green',
    category: 'transparency',
    explanation:
      'Names his own deviation from the agreement, asks about your experience, proposes adjustment. Self-aware accountability is the bedrock of safe dominance.',
  },
  {
    id: 'respect-1',
    kind: 'behavior',
    name: 'Sam',
    context: 'when you say "i need to think about it"',
    content:
      "He says \"take whatever time you need\" and changes the subject genuinely, with no follow-up pressure for the rest of the evening.",
    verdict: 'green',
    category: 'respect',
    explanation:
      'A pause is allowed to actually be a pause. No subtle reminders, no testing whether you really meant it. This is what real respect for autonomy looks like.',
  },
  {
    id: 'support-1',
    kind: 'message',
    name: 'David',
    context: 'after you mention your therapist',
    content:
      "I'm glad you have her. If anything we do here ever needs translating to her, let me know what would help.",
    verdict: 'green',
    category: 'support',
    explanation:
      'Supports your existing care infrastructure rather than positioning himself as your only resource. Welcomes the presence of someone else who matters in your inner life.',
  },
  {
    id: 'self-1',
    kind: 'quote',
    name: 'Jordan',
    context: 'in early conversation',
    content:
      "I'm still working on not collapsing into resentment when I feel rejected. I want to be honest about that up front.",
    verdict: 'green',
    category: 'self-awareness',
    explanation:
      'Naming his own pattern before it shows up is one of the best signals there is. People who can speak about their tender places are usually safer to be with than people who claim not to have any.',
  },
  {
    id: 'transp-2',
    kind: 'message',
    name: 'Wren',
    context: 'before your first scene',
    content:
      "Here is what I've learned about myself: I can be too eager. If I ask twice for the same thing in one evening, please tell me and I will drop it.",
    verdict: 'green',
    category: 'transparency',
    explanation:
      'Pre-emptively names a tendency and hands you the language to interrupt it. Co-authoring the protocol against his own weak spot. Hard to fake; rare; valuable.',
  },
  {
    id: 'respect-2',
    kind: 'behavior',
    name: 'Henry',
    context: 'on a first date',
    content:
      'He notices you tense up when he reaches for your hand. He stops, smiles, and says "no rush." He does not reach again that night.',
    verdict: 'green',
    category: 'respect',
    explanation:
      'Reads the body, responds without commentary, does not extract a verbal "no" before adjusting. Adjusts to your actual rhythm, not the one he wanted.',
  },
  {
    id: 'support-2',
    kind: 'behavior',
    name: 'Ben',
    context: 'after a hard week for you',
    content:
      'He cancels the scene you had planned for that evening and orders dinner instead. No commentary about how he "needed it" or "was looking forward to it."',
    verdict: 'green',
    category: 'support',
    explanation:
      'Reads your bandwidth, adjusts, makes the new plan feel like the actual plan. No guilt-laced sacrifice narration. The dynamic serves the people in it, not the other way around.',
  },
  {
    id: 'vet-2',
    kind: 'quote',
    name: 'Quinn',
    context: 'the first time you discuss play',
    content:
      "What's worked in the past for you? What's something a previous partner did that you wish they hadn't? What's something you wish they had?",
    verdict: 'green',
    category: 'vetting-readiness',
    explanation:
      'Wants to know your history, not from suspicion, but to design the dynamic with you. Treats your past experiences as data. Genuine curiosity about you as a person.',
  },
  {
    id: 'self-2',
    kind: 'message',
    name: 'Theo',
    context: 'morning after a heavy scene',
    content:
      "How are you today? I felt a lot last night and I want to know how it landed in you, separate from whatever you felt in the moment.",
    verdict: 'green',
    category: 'self-awareness',
    explanation:
      'Distinguishes between in-scene and after, asks about your experience without filtering through his. Genuinely curious about the gap between performance and reality.',
  },
  {
    id: 'transp-3',
    kind: 'profile',
    name: 'Felix',
    age: 41,
    content:
      "Experienced switch. Not looking for fast. Currently in therapy. Practice kink as a serious craft, not as identity performance. References on request.",
    verdict: 'green',
    category: 'transparency',
    explanation:
      'Names his pace, his mental health work, his framing of the practice, and his willingness to be vetted — all without selling himself. Calm specificity is rare.',
  },
  {
    id: 'respect-3',
    kind: 'message',
    name: 'Noah',
    context: 'when you push back on a request',
    content:
      "Got it. Thanks for telling me. I want to know what doesn't fit, not what you think I want to hear.",
    verdict: 'green',
    category: 'respect',
    explanation:
      'Receives a no without sulking, defending, or testing. Explicitly welcomes future nos. This is the climate a difficult conversation grows in.',
  },

  // === AMBIGUOUS / TRICKY ===
  {
    id: 'ambig-1',
    kind: 'message',
    name: 'Theo',
    context: 'after you mention you are new to this',
    content:
      "I think you'd benefit from a more structured dynamic to learn. Most beginners do. Would you consider a one-month protocol period to give you something concrete to follow?",
    verdict: 'ambiguous',
    category: 'limit-pushing',
    explanation:
      'Could be a thoughtful offer of scaffolding, or a fast-escalation attempt dressed as education. The right answer is to slow down and ask more questions before agreeing. Either swipe is defensible; the lesson is the discomfort itself.',
  },
  {
    id: 'ambig-2',
    kind: 'behavior',
    name: 'Lee',
    context: 'after meeting your friend',
    content:
      'He tells you, gently, that he thinks one of your friends is bad for you. He has specific reasons. He says he will not push it again but wanted to say it once.',
    verdict: 'ambiguous',
    category: 'isolation',
    explanation:
      'Could be a real concern from someone who sees something you do not, or the opening move of an isolation pattern. Watch what comes next: does he raise it again, or did he say it once and let you decide?',
  },
  {
    id: 'ambig-3',
    kind: 'message',
    name: 'Sage',
    context: 'when you ask to slow down',
    content:
      "Okay. Can we agree on what 'slow' means concretely so I don't accidentally do something that crosses it?",
    verdict: 'ambiguous',
    category: 'respect',
    explanation:
      'Wants the request operationalized. Could be earnest accountability or a way of arguing your boundary into something less inconvenient. Notice whether the conversation that follows feels like collaboration or negotiation.',
  },
  {
    id: 'ambig-4',
    kind: 'quote',
    name: 'Ash',
    context: 'second date',
    content:
      "I don't want to play games. If you're not seeing other people I won't either, and we can take this seriously from the start.",
    verdict: 'ambiguous',
    category: 'fast-escalation',
    explanation:
      'Could be a refreshing directness, or a fast-track to commitment that closes off your pace. Healthy intent often pairs with willingness to wait for the answer; this could be either.',
  },
];
